const convertColor = require('hsl-to-rgb-for-reals');
const { i18n } = require('../../config');
const icons = require('./icons');

function calculateColor(percentage) {
	const colors = [
		[349, 1, 0.35],
		[21, 1, 0.43],
		[158, 1, 0.3]
	];

	let color = colors[0];

	if (percentage > 66) {
		color = colors[2];
	} else if (percentage > 33) {
		color = colors[1];
	}

	// let hue = (percentage / 100) * 169 - 11;

	// if (hue < 0) {
	// 	hue += 360;
	// }

	const rgb = convertColor(...color);
	const rgba = [...rgb, 1];

	return `rgba(${rgba.join(',')})`;
}

function getColor(graph) {
	let value = graph.inverted ? 100 - graph.value : graph.value;

	if (graph.simple) {
		value = value ? 100 : 0;
	}

	const color = calculateColor(value);

	return color;
}

function getLabel(graph, locale = 'de') {
	if (graph.simple) {
		return `${graph.value}%`;
	}

	const chartLabels = i18n.chartLabels[locale];

	let label = chartLabels[0];

	if (graph.value >= 50) {
		label = chartLabels[1];
	}

	return label;
}

function getIcon(graph) {
	let index = graph.value > (2 * 100) / 3 ? 2 : graph.value < 100 / 3 ? 0 : 1;

	if (graph.inverted) {
		index = 2 - index;
	}

	const icon = icons[graph.name][index];

	return icon;
}

module.exports = { getColor, getLabel, getIcon };
